<template>
  <!-- 勘定書出力 -->
  <t-card v-loading="showFlag">
    <div
      :style="{
        height: basicHeight + 'px',
        'padding-top': '10px',
        'padding-bottom': '10px',
      }"
    >
      <!-- UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓ -->
      <!-- <t-form
        ref="accountOutputForm"
        :model="accountOutputForm"
        domain="accountOutputForm"
        label-position="right"
        label-width="110px"
        class="supplierInfoForm"
      > -->
      <t-form
        ref="accountOutputForm"
        :model="accountOutputForm"
        domain="accountOutputForm"
        label-position="right"
        label-width="120px"
        class="supplierInfoForm"
      >
        <!-- UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑ -->
        <t-row>
          <t-col :span="12">
            <!-- 年月 -->
            <t-form-item :label="$t('resource.utilizeSet.exrMonth')">
              <!--日付 -->
              <t-date-picker
                v-model="accountOutputForm.accountDateYm"
                :clearable="false"
                type="month"
                :placeholder="$t('resource.sys.hidden')"
                value-format="yyyy/MM"
                format="yyyy/MM"
                style="width: 90%"
                :editable="false"
              >
              </t-date-picker>
            </t-form-item>
          </t-col>
          <t-col :span="12">
            <!-- 支付日 -->
            <t-form-item
              :label="$t('resource.CUSTOMER_PAY.PAY_DATE_CH')"
              prop="supAbb"
            >
              <t-date-picker
                v-model="accountOutputForm.payDate"
                :clearable="false"
                type="date"
                :placeholder="$t('resource.sys.hidden')"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                style="width: 90%"
                :editable="false"
              >
              </t-date-picker> </t-form-item
          ></t-col>
        </t-row>

        <t-row>
          <t-col :span="12">
            <!-- 税率(%) -->
            <t-form-item
              :label="$t('resource.documentSet.dsProTaxRate')"
              prop="dsProTaxRate"
            >
              <t-input-number
                v-model="accountOutputForm.taxRate"
                maxLength="50"
                :controls="false"
                :precision="2"
                :max="100"
                class="rateInputStyle"
                style="width: 90%"
                @focus="selectValue($event)"
              ></t-input-number>
            </t-form-item>
          </t-col>
        </t-row>

        <t-row>
          <div>
            <t-col :span="24" class="right">
              <!-- 確定  -->

              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                @click="confirm"
                >{{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
          </div>
        </t-row>
      </t-form>
    </div>
  </t-card>
</template>
<script>
import { t } from "@/locales";
import { outputExcelToZip } from "@/services/common";
import { httpApi } from "@/api/api";

import { Modal, Message } from "@tellus/component";
import { DIALOG_LINE_HEIGHT, NUM_ZERO } from "@/utils/const";
import {
  formatDateStrToyyyyMMdd,
  formatDateToString,
  formatDateyyyyMMdd,
} from "@/utils/comFunction";
export default {
  data() {
    return {
      accountOutputForm: {
        accountDateYm: "", //年月
        payDate: "", //支付日
        taxRate: "", //税率(%)
      },
      showFlag: false,
      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 3 + 35,
    };
  },

  mounted() {
    // 初期化
    this.init();
  },
  // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
  watch: {
    "accountOutputForm.accountDateYm"(value) {
      const [y, m] = value.split("/").map(Number);
      this.accountOutputForm.payDate = formatDateToString(
        new Date(y, m + 1, 15)
      );
    },
  },
  // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

  methods: {
    // 初期化
    init() {
      // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // 「支払日」：「年月」の1.5ヶ月後（デフォルト：15日）
      // this.accountOutputForm.accountDateYm = new Date();
      // this.accountOutputForm.payDate = new Date();
      // 「年月」 new Date => yyyy/MM
      const currentDate = new Date();
      this.accountOutputForm.accountDateYm = `${currentDate.getFullYear()}/${String(
        currentDate.getMonth() + 1
      ).padStart(2, "0")}`;
      // 「支払日」
      this.accountOutputForm.payDate = formatDateToString(
        new Date(new Date().getFullYear(), new Date().getMonth() + 2, 15)
      );
      // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
    },

    // 确定ボタン
    confirm() {
      if (!this.showFlag) {
        this.showFlag = true;
      }
      if (
        !this.accountOutputForm.taxRate ||
        this.accountOutputForm.taxRate == "" ||
        this.accountOutputForm.taxRate == NUM_ZERO
      ) {
        Modal.showWarning("", t("message.CUS_PAY.TAX_RATE_INPUT"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        this.showFlag = false;
        return;
      }

      outputExcelToZip(
        httpApi.OutPutAccountExcel,
        this.accountOutputForm
      ).finally(() => {
        this.showFlag = false;
      });
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },

    // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },
    // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
  },
};
</script>
<style lang="scss" scoped>
</style>
